"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const nmr_processing_1 = require("nmr-processing");
const react_2 = require("react");
const ScaleContext_1 = require("../context/ScaleContext");
const highlight_1 = require("../highlight");
const useActiveSpectrumStyleOptions_1 = __importDefault(require("../hooks/useActiveSpectrumStyleOptions"));
const style = (0, react_1.css) `
  &:hover {
    fill: #ff6f0057 !important;
  }
`;
function ExclusionZoneAnnotation({ zone, color, vAlign, spectrumID, filterId, }) {
    const { scaleX, scaleY } = (0, ScaleContext_1.useScaleChecked)();
    const type = filterId === nmr_processing_1.Filters.signalProcessing.id
        ? highlight_1.HighlightEventSource.MATRIX_GENERATION_EXCLUSION_ZONE
        : highlight_1.HighlightEventSource.EXCLUSION_ZONE;
    const highlight = (0, highlight_1.useHighlight)([], {
        type,
        extra: { zone, spectrumID },
    });
    const { opacity } = (0, useActiveSpectrumStyleOptions_1.default)(spectrumID);
    return ((0, jsx_runtime_1.jsx)("g", { transform: `translate(${scaleX()(zone.to)},0)`, children: (0, jsx_runtime_1.jsx)("rect", { x: "0", css: style, transform: `translate(0,${scaleY()(0) - (vAlign + 5)})`, width: `${scaleX()(zone.from) - scaleX()(zone.to)}`, height: "10px", style: {
                fill: filterId === nmr_processing_1.Filters.signalProcessing.id ? 'gray' : color,
                opacity,
            }, ...highlight.onHover }) }, zone.id));
}
exports.default = (0, react_2.memo)(ExclusionZoneAnnotation);
